import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import dayjs from 'dayjs';

import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Chip from '@mui/material/Chip';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { getEquipmentsById } from 'components/axios/equipmentAxios';
import { getAttentionObservationsByQuery, getEquipmentAlertsById, patchAttentionObservationsRelease } from 'components/axios/equipmentAlertsAxios';
import { getMaintenanceTasksById, patchMaintenanceTasksConfirm } from 'components/axios/maintenanceAxios';
import { getStationsByQuery } from 'components/axios/stationAxios';
import MainCard from 'components/MainCard';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import EquipmentAlertListCard from './mainCard/EquipmentAlertListCard';
import EquipmentStatusCard from './mainCard/EquipmentStatusCard';
import EquipmentAlertAndInspectionTable from 'components/table/EquipmentAlertAndInspectionTable';
import FileDownloadIcon from 'components/FileDownloadIcon';
import ConstantInspectionFollowActionTypeRequestLayer from 'components/layer/ConstantInspectionFollowActionTypeRequestLayer';
// import EquipmentSuspendRequestLayer from 'components/layer/EquipmentSuspendRequestLayer';
import AttentionObservationRequestLayer from 'components/layer/AttentionObservationRequestLayer';
import MaintenanceRequestLayer from 'components/layer/MaintenanceRequestLayer';
import ComprehensiveReportLayer from 'components/layer/ComprehensiveReportLayer';
import { useTheme } from 'components/ThemeContext';

const EquipmentAlertViewMonitoringPage = ({alertId:id}) => {
    const { getEnumValueByEnumNameAndCode, role } = useEnumApi();
    const { t } = useTranslation();
    const { mode } = useTheme();

    const today = new Date();
    const todayNum = dayjs(today).format("YYYYMMDD");

    const [isLoading, setIsLoading] = useState(false);
    
    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
      openModal(modals.alertModal, {
          onClose : () => {
              console.log(1111);
          },
          message: alertMessage,
      });
    };

    const [equipmentAlert, setEquipmentAlert] = useState(null);
    const [info, setInfo] = useState(null);
    const [station, setStation] = useState(null);
    const [previewImage, setPreviewImage] = useState(process.env.PUBLIC_URL+"/img/sample.png");

    const [attentionObservation, setAttentionObservation] = useState();
    const [maintenanceTask, setMaintenanceTask] = useState();
    
    useEffect(() => {
        equipmentAlertInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[id, isLoading]);

    const equipmentAlertInfo = () => {
        if (id) {
            Promise.all([
                getEquipmentAlertsById(id).then((data)=>{
                    setEquipmentAlert(data);
                    return data;
                }),
                getAttentionObservationsByQuery({"equipmentAlert.id" : id}).then((observe)=>{
                  if (observe && observe._embedded) {
                      setAttentionObservation(observe._embedded.attentionObservations[0]);
                  } else {
                      setAttentionObservation(null);
                  }
              })
            ]).then((res)=>{
                if (res && res[0]) {
                    Promise.all([
                        getEquipmentsById(res[0].equipment.id).then((res1)=>{
                            setInfo(res1);
                        }),
                        getStationsByQuery({id:res[0].equipment.station.id}).then((data2)=>{
                            if (data2 && data2._embedded) {
                                setStation(data2._embedded.stations[0]);
                            }
                        })
                    ]).then(()=>{
                      if (res[0].mntTask && res[0].mntTask.id) {
                        getMaintenanceTasksById(res[0].mntTask.id).then((task) => {
                          if (task) {
                              setMaintenanceTask(task);
                          } else {
                              setMaintenanceTask(null);
                          }
                        })
                      } else {
                        setMaintenanceTask(null);
                      }
                    })
                }
                setIsLoading(true);
            })
        }
    }

    useEffect(()=>{
      // if (info && info.imgFile) {
      //     setImageFromFile(info.imgFile);
      // } else {
      //     setPreviewImage(mode === 'white' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
      // }
      if (info) {
        if (info && info.imgFiles && info.imgFiles.length > 0) {
          setImageFromFile(info.imgFiles[0]);
        } else {
          setPreviewImage(mode === 'white' ? process.env.PUBLIC_URL+"/img/sample1.png" : process.env.PUBLIC_URL+"/img/sample.png")
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[info]);

    const setImageFromFile = ( file ) => {
        setPreviewImage(process.env.REACT_APP_API_URL+"/api/download/"+file?.id);
    };

    if (station && equipmentAlert) {
        let level3ClassName = "step_active_n";
        if (equipmentAlert.status === null || equipmentAlert.status === undefined || equipmentAlert.status === 'M') {
          level3ClassName = "step_active";
          if (equipmentAlert.fllwActionType === 'O2_OBSERVE') {
            if (attentionObservation) {
              if (attentionObservation.endYmd === undefined || (attentionObservation.endYmd && attentionObservation.endYmd.replaceAll('-','') >= todayNum)) {
                level3ClassName = "step_active_n";
              } else {
                level3ClassName = "step_active";
              }
            }
          } else if (equipmentAlert.fllwActionType === 'O3_MNT') {
            if (maintenanceTask) {
              if (maintenanceTask.status === 'O1_R') {
                level3ClassName = "step_active_n";
              } else if (maintenanceTask.status === 'O2_P') {
                level3ClassName = "step_active_i";
              } else if (maintenanceTask.status === 'O3_C' || maintenanceTask.status === 'O4_V') {
                level3ClassName = "step_active";
              }
            } else {
              level3ClassName = "step_active_n";
            }
          }
        }

        const risUserModal = (id) => {
          openModal(modals.promptModal, {
              onSubmit : (value) => {
                  let body = {
                      id,
                      risUser : value
                  }
                  patchAttentionObservationsRelease(id, body).then((res) => {
                      setIsLoading(false);
                  })
              },
              onClose : () => {
                  console.log('close');
              },
              message: t('message.common.alert.release.handler.input'),
              originValue : ''
          });
        }

        const confirmUserModal = (id) => {
          openModal(modals.promptModal, {
            onSubmit : (value) => {
                let body = {
                    id,
                    confirmUser : value,
                }
                patchMaintenanceTasksConfirm(id, body).then((res) => {
                    alertMessage = t('message.common.alert.confirm.complete');
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                    setIsLoading(false);
                })
            },
            onClose : () => {
                console.log('close');
            },
            message: t('message.common.alert.maintenance.confirm.handler.input'),
            originValue : ''
          });
        }

        let observeStatusCode = '';
        if (attentionObservation) {
          if (attentionObservation.status) {
            observeStatusCode = attentionObservation.status;
          }
          // if (attentionObservation.endYmd) {
          //   let endYmd = attentionObservation.endYmd.replaceAll('-','');
          //   if (endYmd >= todayNum) { // 유효
          //       observeStatusCode = "V";
          //   } else {  // 해제
          //       observeStatusCode = "R";
          //   }
          // } else {
          //   observeStatusCode = "V";
          // }
        }

        if (isLoading) {
          let titleLinkUrl = "../";
          return (
          <div className="sub_container">
            <div className="moni_tit_box">
            <h5 style={{color:"#fff", borderRadius:"0"}}>
            {/* <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway.png`} alt='' /></span>&nbsp;
              <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}`}>
              {getEnumValueByEnumNameAndCode("SubwayLine", station.workingPart.subwayLine) && getEnumValueByEnumNameAndCode("SubwayLine", station.workingPart.subwayLine)[0].title} 
              </Link>
              <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}`}>
              &gt; {station.workingPart.name} 
              </Link>
              <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}`}>
              &gt; ({station.code}){station.name}
              </Link>
              <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}&searchlevel1=${equipmentAlert.equipment.equipmentCtgr.parent.parent.id}&searchlevel2=${equipmentAlert.equipment.equipmentCtgr.parent.id}`}>
              &gt; {equipmentAlert.equipment && equipmentAlert.equipment.equipmentCtgr && equipmentAlert.equipment.equipmentCtgr.parent && (equipmentAlert.equipment.equipmentCtgr.parent.name || '')} 
              </Link>
              <Link to={`${titleLinkUrl}?searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}&searchlevel1=${equipmentAlert.equipment.equipmentCtgr.parent.parent.id}&searchlevel2=${equipmentAlert.equipment.equipmentCtgr.parent.id}&searchlevel3=${equipmentAlert.equipment.equipmentCtgr.id}`}>
              &gt; {equipmentAlert.equipment && equipmentAlert.equipment.equipmentCtgr && (equipmentAlert.equipment.equipmentCtgr.name || '')}
              </Link>
              <Link to={`${titleLinkUrl}?searchField=name&searchKeyword=${equipmentAlert.equipment.name}&searchSubway=${station.workingPart.subwayLine}&searchWorkingPart=${station.workingPart.id}&searchStation=${station.id}&searchlevel1=${equipmentAlert.equipment.equipmentCtgr.parent.parent.id}&searchlevel2=${equipmentAlert.equipment.equipmentCtgr.parent.id}&searchlevel3=${equipmentAlert.equipment.equipmentCtgr.id}`}>
              &gt; {equipmentAlert.equipment && equipmentAlert.equipment.name || ''}
              </Link> */}
              {equipmentAlert.equipment?.name}({equipmentAlert.equipment?.equipmentNo})
              </h5>
              &nbsp;<ComprehensiveReportLayer info={info} station={station} previewImage={previewImage} />
            </div>

            <Row>
              <Col sm={8} className="sub_left">
                <div className='alert_phrase'>
                  <MainCard className="center_table" content={false}>
                    <div className="stpes" style={{display:"flex", alignItems:"center", backgroundColor:"#353535", flexWrap:"wrap"}}>
                      <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                      <Chip label={t('message.common.chip.alert.site.inspection.detail')} color="error" />
                      <div>
                        <ul style={{marginBottom:"0"}}>
                          <li className={`step_active`}><span style={{padding:"4px 12px"}}>1</span><span>{t('message.common.subtitle.alert.generation')}</span></li>
                          <li>&gt;&gt;&nbsp;</li>
                          <li className={`step_active${(equipmentAlert.status === 'F' || (equipmentAlert.status === null || equipmentAlert.status === undefined || equipmentAlert.status === 'M')) ? "" : "_n"}`}><span>2</span><span>{t('message.common.chip.constantInspection')}</span></li>
                          <li>&gt;&gt;&nbsp;</li>
                          <li className={level3ClassName}>
                            <span>3</span>
                            {(equipmentAlert.status === null || equipmentAlert.status === undefined || equipmentAlert.status === 'M') ?
                            <span>{getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType) && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)[0].title}</span> : <span>{t('message.common.subtitle.fllwActionType')}</span>
                            }
                          </li>
                        </ul>
                      </div>
                    </div>
                    <EquipmentAlertAndInspectionTable equipmentAlert={equipmentAlert} />
                  </MainCard>
                </div>

                {equipmentAlert && equipmentAlert.fllwActionType === 'O3_MNT' 
                    && maintenanceTask === null &&
                <div className='alert_phrase'>
                  <MainCard content={false} style={{marginBottom:"10px"}}>
                      <TableContainer>
                      <Table aria-label="simple table" className="green_table maint_table">
                          <TableBody>
                          <TableRow className='td_green'>
                              <TableCell className="th" style={{width:"150px"}}>{t('message.common.title.maintenance')}</TableCell>
                              <TableCell>{t('message.common.text.wait')}</TableCell>
                              {role !== ROLE.MO.code &&
                              <TableCell>
                                  <div style={{textAlign:"right"}}>
                                  {equipmentAlert.fllwActionType === 'O3_MNT' && maintenanceTask === null && <><MaintenanceRequestLayer alertId={equipmentAlert.id} setIsLoading={setIsLoading} />&nbsp;&nbsp;</>}
                                  </div>
                              </TableCell>
                              }
                          </TableRow>
                          </TableBody>
                      </Table>
                      </TableContainer>
                  </MainCard>
                </div>
                }
    
                {/* 버튼 */}
                {role !== ROLE.MO.code &&
                <div className="btn_right" style={{marginBottom:"15px"}}>
                  {/* <EquipmentSuspendRequestLayer equipment={info} equipmentAlertId={equipmentAlert.id} setIsLoading={setIsLoading} />&nbsp;&nbsp; */}
                  {equipmentAlert.fllwActionType ?
                    <>
                      {equipmentAlert.fllwActionType === 'O2_OBSERVE' && attentionObservation === null && <><AttentionObservationRequestLayer alertId={equipmentAlert.id} setIsLoading={setIsLoading} />&nbsp;&nbsp;</>}
                      {equipmentAlert.fllwActionType === 'O2_OBSERVE' && attentionObservation && <><AttentionObservationRequestLayer alertId={equipmentAlert.id} setIsLoading={setIsLoading} type="modify" />&nbsp;&nbsp;</>}
                    </>
                  : ""}
                  <ConstantInspectionFollowActionTypeRequestLayer alertId={equipmentAlert.id} setIsLoading={setIsLoading} /*type={"icon"}*/ />
                </div>
                }
                
                {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O2_OBSERVE' && attentionObservation && (
                <>
                  <div className='alert_phrase'>
                    <MainCard className="center_table" content={false}>
                      <div className="stpes" style={{display:"flex", alignItems:"center", backgroundColor:"#353535", flexWrap:"wrap"}}>
                        <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                        <Chip label={t('message.common.btn.observe')} color="error" style={{backgroundColor:'#e7c748'}} />
                      </div>
                      <TableContainer>
                        <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width" style={{borderCollapse:"unset", borderSpacing:"revert"}}>
                          <TableBody>
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.observe.startYmd')}</TableCell>
                              <TableCell colSpan={2}align="center">{attentionObservation.regYmd}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.observe.endYmd')}</TableCell>
                              <TableCell colSpan={2} align="center">{attentionObservation.endYmd}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.observe.detail')}</TableCell>
                              <TableCell className="pl" colSpan={5} style={{textAlign:"left"}}>
                                {attentionObservation.remark}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.write.handler')}</TableCell>
                              <TableCell colSpan={3} align="center">{attentionObservation.regUser}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.status')}</TableCell>
                              <TableCell align="center">
                                <div className={attentionObservation.status === 'V' ? "condition1":"condition4"}>
                                  {getEnumValueByEnumNameAndCode("AttentionObservationStatus", attentionObservation?.status)?.[0]?.title}
                                </div>
                              </TableCell>
                            </TableRow>
                            {attentionObservation.risYmd && attentionObservation.risUser &&
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.observe.release.date')}</TableCell>
                              <TableCell colSpan={3} align="center">{attentionObservation.risYmd}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.release.handler')}</TableCell>
                              <TableCell align="center">{attentionObservation.risUser}</TableCell>
                            </TableRow>
                            }
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </MainCard>
                  </div>
                  {role !== ROLE.MO.code &&
                  <div className="btn_right">
                      <div>
                          <AttentionObservationRequestLayer alertId={equipmentAlert.id} setIsLoading={setIsLoading} type="modify" />
                          &nbsp;&nbsp;
                          {observeStatusCode === 'V' && 
                          <Button variant="contained" color='error' onClick={()=>{risUserModal(attentionObservation.id)}}>{t('message.common.text.release')}</Button>
                          }
                      </div>
                  </div>
                  }
                </>
                )}

                {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O3_MNT' && maintenanceTask &&
                <>
                  <div className='alert_phrase'>
                    <MainCard className="center_table" content={false}>
                      <div className="stpes" style={{display:"flex", alignItems:"center", backgroundColor:"#353535", flexWrap:"wrap"}}>
                        <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/subway1.png`} alt='' /></span>&nbsp;
                        <Chip label={t('message.common.title.maintenance')} color="success" />
                      </div>
                      <TableContainer>
                        <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width" style={{borderCollapse:"unset", borderSpacing:"revert"}}>
                          <TableBody>
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.equipment.component')}</TableCell>
                              <TableCell align="center">{maintenanceTask.equipmentCtgr && maintenanceTask.equipmentCtgr.name}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.provider.type')}</TableCell>
                              <TableCell align="center">{maintenanceTask.mntSpType && getEnumValueByEnumNameAndCode("MaintenanceProviderType", maintenanceTask.mntSpType) && getEnumValueByEnumNameAndCode("MaintenanceProviderType", maintenanceTask.mntSpType)[0].title}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.analysis.type')}</TableCell>
                              <TableCell align="center">{maintenanceTask.recordType && getEnumValueByEnumNameAndCode("MaintenanceRecordType", maintenanceTask.recordType) && getEnumValueByEnumNameAndCode("MaintenanceRecordType", maintenanceTask.recordType)[0].title}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.breakdown.maintenance.date')}</TableCell>
                              <TableCell align="center">{maintenanceTask.troubledAt && dayjs(maintenanceTask.troubledAt).format("YYYY-MM-DD")}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.breakdown.maintenance.time')}</TableCell>
                              <TableCell align="center">{maintenanceTask.troubledAt && dayjs(maintenanceTask.troubledAt).format("HH:mm:ss")}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.breakdown.maintenance.cause')}</TableCell>
                              <TableCell align="center">{maintenanceTask.troubleReason}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.work.start.date')}</TableCell>
                              <TableCell align="center">{maintenanceTask.workingBgnAt && dayjs(maintenanceTask.workingBgnAt).format("YYYY-MM-DD")}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.work.start.time')}</TableCell>
                              <TableCell align="center">{maintenanceTask.workingBgnAt && dayjs(maintenanceTask.workingBgnAt).format("HH:mm:ss")}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.used.equipment')}</TableCell>
                              <TableCell align="center">{maintenanceTask.usedMethod}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.work.end.date')}</TableCell>
                              <TableCell align="center">{maintenanceTask.workingEndAt && dayjs(maintenanceTask.workingEndAt).format("YYYY-MM-DD")}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.work.end.time')}</TableCell>
                              <TableCell align="center">{maintenanceTask.workingEndAt && dayjs(maintenanceTask.workingEndAt).format("HH:mm:ss")}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.actionType')}</TableCell>
                              <TableCell align="center">{maintenanceTask.type && getEnumValueByEnumNameAndCode("MaintenanceType", maintenanceTask.type) && getEnumValueByEnumNameAndCode("MaintenanceType", maintenanceTask.type)[0].title}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.worker')}</TableCell>
                              <TableCell colSpan={3} align="center">{maintenanceTask.worker}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.work.status')}</TableCell>
                              <TableCell align="center">
                                <div className={(maintenanceTask.status === 'O1_R' ? "condition1":(maintenanceTask.status === 'O2_P' ? "condition3":
                                    (maintenanceTask.status === 'O3_C' ? "condition6":"condition5")))}>
                                    {(maintenanceTask.status && getEnumValueByEnumNameAndCode("MaintenanceStatus", maintenanceTask.status) && getEnumValueByEnumNameAndCode("MaintenanceStatus", maintenanceTask.status)[0].title)}
                                </div>
                                {maintenanceTask.status && maintenanceTask.status === 'O4_V' && (""+maintenanceTask.confirmUser)}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.work.detail')}</TableCell>
                              <TableCell className="pl" colSpan={5} style={{textAlign:"left"}}>
                                {maintenanceTask.remark}
                              </TableCell>
                            </TableRow>
                            {maintenanceTask.equipmentParts &&
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.input.material')}</TableCell>
                              <TableCell className="pl" colSpan={5} style={{textAlign:"left",padding:"0"}}>
                                <Table sx={{ minWidth: 800 }} aria-label="simple table">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell className="th" align="center">{t('message.common.subtitle.material')}</TableCell>
                                      <TableCell className="th" align="center">{t('message.common.subtitle.quantity')}</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {maintenanceTask.equipmentParts.map(function(item, i) {
                                      return (
                                    <TableRow key={i}>
                                      <TableCell align="center">{item.masterEquipmentPart.name}</TableCell>
                                      <TableCell align="center">{item.cnt}</TableCell>
                                    </TableRow>
                                      )
                                    })}
                                  </TableBody>
                                </Table>
                              </TableCell>
                            </TableRow>
                            }
                            <TableRow>
                              <TableCell className="th" align="center">{t('message.common.subtitle.expense')}</TableCell>
                              <TableCell align="center">&#8361; {maintenanceTask.cost && maintenanceTask.cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.status.report.date')}</TableCell>
                              <TableCell align="center">{maintenanceTask.statusReport && maintenanceTask.statusReport.reportYmd}</TableCell>
                              <TableCell className="th" align="center">{t('message.common.subtitle.status.report.file')}</TableCell>
                              <TableCell align="center">
                                {maintenanceTask.statusReport && maintenanceTask.statusReport.reportFiles && maintenanceTask.statusReport.reportFiles.map(function(file, idx) {
                                    return (
                                      <div key={idx}><FileDownloadIcon file={file} viewFileName={true}/>{(maintenanceTask.statusReport.reportFiles-1)>idx && <br/>}</div>
                                    )
                                  })
                                }
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </MainCard>
                  </div>
                  { role !== ROLE.MO.code &&
                  <div className="btn_right">
                      <div>
                          <MaintenanceRequestLayer alertId={equipmentAlert.id} setIsLoading={setIsLoading} type="modify" />
                          &nbsp;&nbsp;
                          {(maintenanceTask && maintenanceTask.status === 'O3_C' && (role === ROLE.SA.code || role === ROLE.WA.code)) &&
                          <Button variant="contained" 
                          onClick={()=>{confirmUserModal(maintenanceTask.id)}}>{t('message.common.btn.maintenance.confirm')}</Button>
                          }
                      </div>
                  </div>
                  }
                </>
                }

                {/* 점검내역추적관리 */}
                <EquipmentAlertListCard equipmentId={info && info.id} equipmentNo={info && info.equipmentNo} setIsLoading={setIsLoading} />

                <div style={{marginTop:"10px"}}>
                    <Link to={'..'+window.location.search}><Button variant="contained" color="primary">{t('message.common.btn.list')}</Button></Link>
                </div>
              </Col>
    
              <Col sm={4} className="sub_right">
                {/* 설비 현황 및 상태 */}
                <EquipmentStatusCard info={info} station={station} setIsLoading={setIsLoading} />    
              </Col>
            </Row>
          </div>
        )
      }
    }
}

export default EquipmentAlertViewMonitoringPage;